<template>

    <div class="feedback__end">

        <img v-if="$mq === 'lg' && step === 4" class="feedback__close pointer" src="/img/icons/cancel-grey.svg" @click="close">

        <!--STEP 4-->
        <template v-if="step === 4">

            <h1 class="cf-headline">{{ $t('feedback_sad_survey_title_select') }}</h1>

            <div class="feedback__step-4__container">

                <template v-for="(item, index) in improvements">

                    <div :class="{ 'feedback__step-4__badge-active': item.active }" class="feedback__step-4__badge pointer noselect" @click="toggleBadge(index)">{{
                            item.name
                        }}
                    </div>

                </template>

            </div>

            <div class="feedback__step-4__divider"></div>

            <h1 class="cf-headline">{{ $t('feedback_sad_survey_title_other') }}</h1>

            <textarea v-model="message" :placeholder="$t('feedback_sad_survey_placeholder_other')" class="feedback__step-4__text-area"></textarea>

            <button :class="{ 'feedback__step-4__btn-active': computedBtnActive }" class="btn btn-new feedback__step-4__btn" @click="submitForm">

                <template v-if="requesting">

                    <LottieLoader></LottieLoader>

                </template>

                <template v-else>{{ $t('feedback_sad_survey_cta_submit') }}</template>
            </button>

        </template>


        <!--STEP 5-->
        <template v-if="step === 5">

            <h1 class="cf-headline">{{ $t('feedback_sad_thanks_title') }}</h1>

            <p class="feedback__step-5__text">{{ $t('feedback_sad_thanks_text') }}</p>

            <button class="btn btn-green btn-new feedback__step-5__btn" @click="close">{{ $t('feedback_sad_thanks_cta') }}</button>

        </template>

    </div>


</template>

<script>

import LottieLoader from '@/components/lottie/LottieLoader'

export default {

    name: 'feedback-end',

    components: {LottieLoader},

    props: {

        step: {
            type: Number,
            default: 0
        },

        improvements: {
            type: Array,
            default: () => []
        },

        requesting: {
            type: Boolean,
            default: false
        }

    },

    watch: {

        message: function (message) {
            this.$emit('updateMessage', message)
        }

    },

    computed: {

        computedBtnActive: function () {

            return this.improvements.filter(item => item.active).length

        }

    },

    //STEP 1: question
    //STEP 2: yes
    //STEP 3: no
    //STEP 4: form
    //STEP 5: thanks

    data() {
        return {
            message: ''
        }
    },

    methods: {

        submitForm() {

            if (this.computedBtnActive) {

                this.$emit('submitForm')

            }

        },

        toggleBadge(index) {
            this.improvements[index].active = !this.improvements[index].active
        },

        close() {
            this.$emit('close')
        }

    }

}
</script>

<style lang="scss" scoped>

.feedback {

    &__end {
        @media screen and (min-width: $above-tablet-length) {
            position: relative;
            padding: 40px;
            max-width: 480px;
        }
    }

    &__close {
        @media screen and (min-width: $above-tablet-length) {
            position: absolute;
            top: 16px;
            right: 16px;
        }
    }

    &__step-4 {


        &__container {
            margin-top: 4px;
            width: 100%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }

        &__badge {
            margin: 8px 4px 0;
            padding: 8px 12px;
            border-radius: 24px;
            background-color: $timberwolf;
            font-size: 14px;
            line-height: 1.29;
        }

        &__badge-active {
            background-color: $blue;
            color: $white;
        }

        &__divider {
            width: 100%;
            margin: 24px 0 16px;
            height: 1px;
            border-radius: 2px;
            background-color: $timberwolf;
        }

        &__text-area {
            resize: none;
            margin-top: 16px;
            width: 100%;
            height: 142px;
            background-color: $timberwolf;
            border-radius: 6px;
            border: none;
            padding: 8px 12px;

            font-size: 14px;
            line-height: 1.29;
        }

        &__text-area:focus {
            -moz-appearance: none;
            outline: 0px none transparent;
        }

        &__btn {
            background-color: $silver;
            font-size: 17px;
            font-weight: bold;
            color: $stone;
            margin-top: 16px;
            cursor: not-allowed;
        }

        &__btn-active {
            background-color: $green;
            color: $white;
            cursor: pointer;
        }
    }

    &__step-5 {

        &__text {
            font-size: 14px;
            line-height: 1.29;
            margin-top: 16px;
        }

        &__btn {
            font-size: 17px;
            font-weight: bold;
            margin-top: 16px;
        }
    }
}

/*animation*/


</style>
